/**
 * Oscar Theme - Delightful Micro-interactions
 * Adds playful animations and interactive elements
 */

class OscarInteractions {
  constructor() {
    this.init();
  }

  init() {
    this.setupProductCardHovers();
    this.setupButtonRipples();
    this.setupScrollAnimations();
    this.optimizePerformance();
  }

  /**
   * Product card hover effects with paw print trails
   */
  setupProductCardHovers() {
    const productCards = document.querySelectorAll('.product-card, .card');

    productCards.forEach(card => {
      card.addEventListener('mouseenter', (e) => {
        this.createPawPrint(e.currentTarget);
      });
    });
  }

  createPawPrint(element) {
    const paw = document.createElement('div');
    paw.className = 'paw-print';
    paw.innerHTML = '🐾';

    const rect = element.getBoundingClientRect();
    const x = Math.random() * rect.width;
    const y = Math.random() * rect.height;

    paw.style.left = `${x}px`;
    paw.style.top = `${y}px`;

    element.style.position = 'relative';
    element.appendChild(paw);

    // Remove after animation
    setTimeout(() => {
      paw.remove();
    }, 2000);
  }

  /**
   * Button ripple animations on click
   */
  setupButtonRipples() {
    const buttons = document.querySelectorAll('button, .btn, .button, input[type="submit"]');

    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.createRipple(e);
      });
    });
  }

  createRipple(event) {
    const button = event.currentTarget;
    const ripple = document.createElement('span');
    const rect = button.getBoundingClientRect();

    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    ripple.className = 'ripple-effect';
    ripple.style.width = ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    button.style.position = 'relative';
    button.style.overflow = 'hidden';
    button.appendChild(ripple);

    // Remove after animation
    setTimeout(() => {
      ripple.remove();
    }, 600);
  }

  /**
   * Scroll-triggered fade-in animations
   */
  setupScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe elements with fade-in class
    const fadeElements = document.querySelectorAll('.fade-in-up, .product-card, .feature-block');
    fadeElements.forEach(el => {
      el.classList.add('fade-in-up');
      observer.observe(el);
    });
  }

  /**
   * Performance optimizations
   */
  optimizePerformance() {
    // Debounce resize events
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.handleResize();
      }, 250);
    });

    // Throttle scroll events
    let scrolling = false;
    window.addEventListener('scroll', () => {
      if (!scrolling) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          scrolling = false;
        });
        scrolling = true;
      }
    });
  }

  handleResize() {
    // Handle responsive adjustments
    console.log('Window resized - optimized');
  }

  handleScroll() {
    // Handle scroll-based effects
    const scrolled = window.pageYOffset;
    document.documentElement.style.setProperty('--scroll-y', `${scrolled}px`);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new OscarInteractions();
  });
} else {
  new OscarInteractions();
}
